import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const OTPVerification = ({ mobileNumber, onVerificationComplete }) => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const { verifyOTP, error } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!otp) return;

    try {
      setLoading(true);
      await verifyOTP(mobileNumber, otp);
      onVerificationComplete();
    } catch (error) {
      console.error('Error verifying OTP:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: 400 }}>
      <Typography variant="h5" gutterBottom>
        Verify OTP
      </Typography>
      
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Enter the 4-digit OTP sent to {mobileNumber}
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TextField
        fullWidth
        label="OTP"
        variant="outlined"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="1234"
        required
        inputProps={{
          maxLength: 4,
          pattern: '[0-9]*',
        }}
        sx={{ mb: 2 }}
      />

      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={loading || !otp}
        sx={{ mt: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : 'Verify OTP'}
      </Button>
    </Box>
  );
};

export default OTPVerification; 